export const isOlderThanNMonths = (isoDate: string, months: number = 1): boolean => {
  const date = new Date(isoDate);

  if (Number.isNaN(date.getTime())) {
    throw new Error('Invalid ISO date');
  }

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - months);

  return date < oneMonthAgo;
};
